// ESLint Settings
/* eslint no-unused-labels: "off", complexity: "off", no-useless-escape: "off" */
/* globals Drupal: true, site: true, TimelineMax: true, TweenMax: true, jQuery: true, hashHelper: true, platformCheck: true */

(function ($) {
  'use strict';

  Drupal.behaviors.ModuleHolidayGetTheLook2018V1 = {
    /* eslint-disable no-unused-vars */
    attach: function (context, settings) {
    /* eslint-enable no-unused-vars */
      // DOM
      var $window = $(window);
      var $boutique = $('#holiday-2018_container', context);
      // LOGIC
      var debug = false;
      var platformVars = platformCheck({
        target: $boutique[0],
        mobileSize: 640,
        mobileClass: 'js-mobile',
        ipadClass: 'js-ipad',
        desktopClass: 'js-desktop',
        ieClass: 'js-ie',
        isMobileCallback: function () {
          return typeof site !== 'undefined' ? site.client.isMobile : (/iphone|ipod|android|blackberry|mini|windows\sce|palm/i).test(navigator.userAgent.toLowerCase());
        }
      });

      // BEGIN: Get The Look
      (function () {
        // DOM
        var $carousels;
        var $deeplinkTarget;
        // LOGIC
        var autoScrollTimeout;
        var autoScrollTime = $('.get-the-look_header').attr('data-timeout-seconds');
        var deeplinkData = hashHelper.get();

        if (!$boutique.hasClass('get-the-look')) {
          return;
        }

        // BEGIN: Mobile Menu Functionality
        (function () {
          // DOM
          var $menuTrigger = $boutique.find('.holiday-2017-primary_nav .button_shop');
          var $menu = $boutique.find('.holiday-2017_side-nav');

          // BEGIN: EVENTS
          events: {
            $menuTrigger.on('click', function (e) {
              var animation;

              // Mobile only functionality
              if (!platformVars.isMobile) {
                return;
              }

              e.preventDefault();

              animation = new TimelineMax();

              if (!$menu.hasClass('active')) {
                animation
                  .to($menuTrigger.find('.arrow'), 0.5, { rotation: '90deg' })
                  .to($menu, 0.5, {
                    y: '0%',
                    className: '+=active'
                  }, '0');
              } else {
                animation
                  .to($menuTrigger.find('.arrow'), 0.5, { rotation: '0deg' })
                  .to($menu, 0.5, {
                    y: '-100%',
                    className: '-=active'
                  }, '0');
              }
            });
          }
          // END: EVENTS
        })();
        // END: Mobile Menu Functionality

        // BEGIN: INIT
        init: {
          $carousels = $boutique.find('.carousel');
          $carousels.el_carousel({
            debug: debug,
            increment: $boutique.hasClass('mobile') ? '100%' : '200%',
            useGSAP: true,
            duration: 1,
            callbackAnimationOptions: {
              useClones: false
            }
          });

          // Desktop functionality
          if (platformVars.isDesktop) {
            // Default to 10 seconds
            if (typeof autoScrollTime === 'undefined' || isNaN(parseInt(autoScrollTime))) {
              autoScrollTime = 10;
            }

            // Set up autoscroll after a set time
            autoScrollTimeout = window.setTimeout(function () {
              TweenMax.to($window, 1, {
                scrollTo: { y: $carousels.offset().top - $('.page-header').height() - $('.header-text-main').outerHeight(true) }
              });
            }, parseInt(autoScrollTime) * 1000);
          }
          // Handle Deeplinking
          if (deeplinkData.length >= 1) {
            // If deeplink data is `1` target the body (usually at scroll position 0), this disregards any previous scroll history
            // If deeplink data is `2`, because mobile and desktop have different layouts we target different elements to scroll to
            $deeplinkTarget = parseInt(deeplinkData[0]) === 1 ? $('body') : platformVars.isMobile && parseInt(deeplinkData[0]) === 2 ? $boutique.find('.details-carousel').first() : $boutique.find('.get-the-look_carousels');
          }
        }
        // END: INIT

        // BEGIN: EVENTS
        events: {
          // Kill inactivity timeout on scroll/click activity
          $window
            .on('postLoad', function () {
              var deeplinkScroll;

              if (typeof $deeplinkTarget !== 'undefined' && $deeplinkTarget.length !== 0) {
                deeplinkScroll = $deeplinkTarget.offset().top;

                if ($deeplinkTarget.is('.get-the-look_carousels, .details-carousel')) {
                  // Scroll to animation for carousels needs to account for the Estee menu header height. Desktop scrolls to the top of the carousel section w/ the header elements
                  deeplinkScroll = deeplinkScroll - $('.page-header').height() - ($deeplinkTarget.is('.get-the-look_carousels') ? $('.header-text-main').outerHeight(true) : 0);
                }

                TweenMax.to($window, 0.5, { scrollTo: { y: deeplinkScroll } });
              }

              // Initialized here to prevent scroll based init events from happening too early
              $window.on('scroll click', function () {
                clearTimeout(autoScrollTimeout);
              });
            })
            .on('platformcheck-update', function (e) {
              // LOGIC
              var flag = e.originalEvent.detail.flag;

              // Desktop mobile width detection
              if (platformVars.isDesktop && (flag & platformCheck.FLAG_MOBILE)) {
                if ($boutique.hasClass('js-mobile')) {
                  $boutique.removeClass('js-mobile');
                  $window.trigger('desktopLostMobile');
                } else {
                  $boutique.addClass('js-mobile');
                  $window.trigger('desktopGainedMobile');
                }
              }

              if (platformVars.isIpad && (flag & platformCheck.FLAG_ORIENTATION)) {
                if (platformVars.orientation) {
                  $boutique.addClass('js-ipad-portrait');
                } else if (platformVars.orientation === false) {
                  $boutique.removeClass('js-ipad-portrait');
                }

                $window.trigger('orientationChanged');
              }
            });

          // Basic carousel progression
          $boutique.find('.arrow').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $carousel = $this.closest('.carousel_container').find('.carousel');

            e.preventDefault();

            if ($this.hasClass('right') && $carousel.length !== 0) {
              $carousel.carouselNext();
            } else if ($this.hasClass('left') && $carousel.length !== 0) {
              $carousel.carouselPrev();
            }
          });

          // Mark clicked model as active, scroll and display related product
          $boutique.find('.get-the-look_header .col').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $aTag = $this.find('a');
            // LOGIC
            var index = $this.index();

            if (platformVars.isMobile) {
              return;
            }

            e.preventDefault();

            // If already selected before, remove highlighting
            if ($this.hasClass('js-active')) {
              $aTag.removeClass('js-active');
              $boutique.find('header').removeClass('js-active');
            // Otherwise highlight and scroll down
            } else {
              $aTag.addClass('js-active');
              $this.siblings().find('a').removeClass('js-active');
              $boutique.find('header').addClass('js-active');

              TweenMax.to($window, 0.5, {
                scrollTo: { y: $carousels.first().offset().top - $('.page-header').height() - $('.header-text-main').outerHeight(true) }
              });

              $carousels.elCarouselTo(index);
            }
          });

          // Close all "Get the look" containers on slide progression
          $carousels.children()
            .on('slideWillLoseActive', function () {
              $(this).find('.close_btn').trigger('click');
              $carousels.find('.description-container').trigger('close', true);
            })
            .on('slideWillGainActive slideHasGainedActive', function () {
              var $this = $(this);
              var animation = $this.data('animation');
              var gainedActiveTimeline = new TimelineMax({
                onComplete: function () {
                  $this.removeData('animation');
                }
              });

              if (typeof animation !== 'undefined') {
                return;
              }

              gainedActiveTimeline.fromTo($(this).find('.overlay-image'), 1, { opacity: 1 }, {
                opacity: 0,
                delay: 1
              });

              $this.data('animation', gainedActiveTimeline);
            });

          // Display respective "Get the look"
          $carousels.find('.get-the-look_button').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $getTheLook = $this.closest('.slide').find('.description-container');
            var $getTheLookDescription = $getTheLook.find('.description-content');
            var $carouselContainer = $this.closest('.carousel_container');
            // LOGIC
            var getTheLookTimeline = new TimelineMax();

            e.preventDefault();

            if ($carouselContainer.hasClass('js-get-the-look_active')) {
              $getTheLook.removeClass('js-active');
              $carouselContainer.removeClass('js-get-the-look_active');
            } else {
              $getTheLook.addClass('js-active');
              $carouselContainer.addClass('js-get-the-look_active');

              if (!platformVars.isMobile) {
                getTheLookTimeline
                  // Set height to container
                  .add(function () {
                    $getTheLook.height($boutique.find('.get-the-look_carousels').height());
                  })
                  .set($getTheLookDescription, { width: $getTheLook.closest('.col.right').width() })
                  .fromTo($getTheLook, 1, { width: 0 }, {
                    width: '100%',
                    immediateRender: false
                  });
              }
            }
          });

          // Hide "Get the look"
          $carousels.find('.description-container').on('click close', function (e, noAnimation) {
            // DOM
            var $this = $(this);
            var $carouselContainer = $this.closest('.carousel_container');

            e.preventDefault();

            if ($(e.target).closest('.close_btn').length !== 0 || e.type === 'close') {
              if (platformVars.isMobile) {
                $this.removeClass('active');
                $carouselContainer.removeClass('js-get-the-look_active');
              } else {
                if (typeof noAnimation === 'boolean' && noAnimation) {
                  TweenMax.set($this, { width: 0 });
                  $this.removeClass('active');
                  $carouselContainer.removeClass('js-get-the-look_active');
                } else {
                  TweenMax.fromTo($this, 1, { width: '100%' }, {
                    width: 0,
                    onComplete: function () {
                      $this.removeClass('active');
                      $carouselContainer.removeClass('js-get-the-look_active');
                    }
                  });
                }
              }
            }
          });

          // Mobile only carousel click functionality
          $carousels.on('click', function (e) {
            // DOM
            var $this = $(this);
            var $parent = $this.closest('.carousel_container');
            var $target;
            var $targetCarousel;
            var $pageHeader = $('.page-header');
            // LOGIC
            var scrollTimeline = new TimelineMax();

            e.preventDefault();

            if (!platformVars.isMobile) {
              return;
            }

            if ($parent.hasClass('eye-looks-selector')) {
              $target = $boutique.find('.eye-looks');
              $targetCarousel = $target.find('.carousel');

              if ($targetCarousel.length === 0) {
                return;
              }

              scrollTimeline.to($window, 0.5, {
                scrollTo: {
                  y: $targetCarousel.offset().top - ($pageHeader.length !== 0 ? $pageHeader.height() : 0),
                  autoKill: false
                }
              });
            } else if ($parent.hasClass('lip-looks-selector')) {
              $target = $boutique.find('.lip-looks');
              $targetCarousel = $target.find('.carousel');

              if ($targetCarousel.length === 0) {
                return;
              }

              scrollTimeline.to($window, 0.5, {
                scrollTo: {
                  y: $targetCarousel.offset().top - ($pageHeader.length !== 0 ? $pageHeader.height() : 0),
                  autoKill: false
                }
              });
            }

            if ($targetCarousel.length !== 0 && typeof $targetCarousel.find('.active').data('animation') !== 'undefined') {
              $targetCarousel.find('.active').data('animation').kill();
              $targetCarousel.find('.active').removeData('animation');
            }

            scrollTimeline.fromTo($targetCarousel.find('.active .overlay-image'), 1, { opacity: 1 }, { opacity: 0 });
          }).swipe({
            swipeLeft: function () {
              $(this).carouselNext();
            },
            swipeRight: function () {
              $(this).carouselPrev();
            },
            excludedElements: 'button, input, select, textarea, .noSwipe',
            preventDefaultEvents: false
          }).on('carousel_updated', function () {
            // DOM
            var $this = $(this);
            var $parentCarousel = $this.closest('.carousel_container');
            // LOGIC
            var activeSlideIndex = $this.find('.active').index();

            // Product Details
            if ($parentCarousel.hasClass('lip-looks')) {
              $boutique.find('.lip-looks-selector .carousel').elCarouselTo(activeSlideIndex);
            } else if ($parentCarousel.hasClass('eye-looks')) {
              $boutique.find('.eye-looks-selector .carousel').elCarouselTo(activeSlideIndex);
            }

            // Product selector
            if ($parentCarousel.hasClass('lip-looks-selector')) {
              $boutique.find('.lip-looks .carousel').elCarouselTo(activeSlideIndex);
            } else if ($parentCarousel.hasClass('eye-looks-selector')) {
              $boutique.find('.eye-looks .carousel').elCarouselTo(activeSlideIndex);
            }
          });

          $('.el-product .el-product_shop-now-container').on('click', function (e) {
            // DOM
            var $this = $(this);
            var $elProduct = $this.closest('.el-product');
            // LOGIC
            var data = $elProduct.data('json_product_full');

            e.preventDefault();

            if (typeof data === 'undefined') {
              return;
            }
          });
        }
        // END: EVENTS
      })();
      // END: Get The Look
    }
  };
})(jQuery);
